import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Administrator/Helpers/AdminTable";
import { subscribesAction } from "../../store/Slices/SubscribesSlice";
import SureModal from "../../components/Modals/SureModal";
import { formateDate } from "../../components/helpers/formateDate";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const Subscribe = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const subsList = useSelector((state) => state.SubscribesSlice.subscribes);
    const loading = useSelector((state) => state.SubscribesSlice.isLoading);

    const rows = subsList?.data?.value?.rows.map((element) => {
        return {
            key: element?.key,
            id: element.id,
            phone: element.phone,
            startDate: element.startDate ? formateDate(element.startDate) : "",
            amount: element.amount,
            club: element.club,
            abonement: element.abonement,
        };
    });

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [subscribeInfo, setSubscribeInfo] = useState();
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    useEffect(() => {
        dispatch(subscribesAction({ flag: "get" }));
    }, []);

    const items = [
        {
            key: "1",
            label: "Отменить подписку",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.mnemo === "cancelRecurrent",
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Подписка" },
        { label: "По токену", value: 2, index: "key", title: "Токен" },
        {
            label: "По номеру телефона",
            value: 3,
            index: "phone",
            title: "Номер телефона",
        },
        { label: "По сумме", value: 4, index: "amount", title: "Сумма" },
        {
            label: "По дате начала",
            value: 5,
            index: "startDate",
            title: "Дата начала",
        },
        { label: "По клубу", value: 6, index: "club", title: "Клуб" },
        {
            label: "По абонементу",
            value: 7,
            index: "abonement",
            title: "Абонемент",
        },
        {
            label: "По платежной системе",
            value: 8,
            index: "paymentSystem",
            title: "Платежная система",
        },
    ];

    const onClickDelete = () => {
        dispatch(
            subscribesAction({ flag: "unSubscribe", value: subscribeInfo.id })
        ).then(() => {
            dispatch(subscribesAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["idFrom"] = values[index][0];
                        formattedItems["idTo"] = values[index][1];
                    } else if (key === "amount") {
                        formattedItems["AmountFrom"] = values[index][0];
                        formattedItems["AmountTo"] = values[index][1];
                    } else if (key === "startDate") {
                        formattedItems["DateFrom"] = values[index][0];
                        formattedItems["DateTo"] = values[index][1];
                    } else if (key === "phone") {
                        formattedItems["Phone"] = values[index][0];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            subscribesAction({
                flag: "get",
                value: {
                    // isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const clickOnAction = (element) => {
        setSubscribeInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            subscribesAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            subscribesAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    return (
        <>
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
                subscribeModal={true}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={loading}
                    onClickRowOne={(record) => {
                        setSubscribeInfo(record);
                    }}
                    columns={subsList}
                    rows={rows}
                    total={subsList?.data?.value?.totalCount}
                    items={items}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={subsList}
                    elementsListLoading={false}
                    setIsOpenAddEditModal={isOpenDeleteModal}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    clickOnAction={clickOnAction}
                    items={items}
                    filterOptionsArr={filterOptionsArr}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Subscribe;
